import type { PageLoad } from './$types';



export const load = (async ({ url }) => {

    let filter: SearchFilter = {}
    url.searchParams.forEach((value:string, key: string) => {
        if(key.startsWith('filter[')){
            // @ts-ignore
            filter[key] = value
        }

    })

    return {
        page_title: "Projects",
        status: url.searchParams.get('status'),
        pageSize: url.searchParams.get('pageSize') || 12,
        page: url.searchParams.get('page') || 1,
        sort: url.searchParams.get('sort') || 'startsAt',
        search: url.searchParams.get('search')  || '',
        order: url.searchParams.get('order') || 'desc',
        ...filter
    };

}) satisfies PageLoad;